<script setup>
defineProps({
  modelValue: Boolean,
  qrUrl: String,
  loading: Boolean,
  agentName: String,
})

defineEmits(['update:modelValue'])
</script>

<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <q-card style="width: 320px">
      <q-card-section class="text-h6 text-weight-bold text-center">
        {{ $t('agents.qrCodeHelperText') }}
      </q-card-section>

      <q-card-section class="text-subtitle2 text-grey-7 q-pt-none text-center">
        {{ agentName }}
      </q-card-section>

      <q-card-section class="flex flex-center">
        <q-spinner v-if="loading" />
        <q-img
          v-else
          :src="qrUrl"
          spinner-color="primary"
          style="width: 240px"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          label="Close"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

